export enum GrowthProgress {
    None = "NONE",
    Seed = "SEED",
    Seedling = "SEEDLING",
    Plant = "PLANT"
}